import store from '@/store/index'
import Moment from 'moment'
import {insertUserBehavior} from "../api/monitoring";
import {GetUrlRelativePath} from "../utils";
export function handleError(error, type) {
  if(type === 1) {
    // 处理接口异常
    // 此时的 error 响应，它的 config 字段中包含请求信息
    let { url, method, params, data } = error.config
    let err_data = {
      url, method,
      params: { query: params, body: data },
      error: error.data.message || JSON.stringify(error.data),
    }
  }
  if(type === 2) {
    // 处理前端异常
    let err_data = null
    // 监测 error 是否是标准类型
    if(error instanceof Error) {
      let { name, message } = error
      err_data = {
        type: name,
        error: message
      }
    } else {
      err_data = {
        type: 'other',
        error: JSON.stringify(error)
      }
    }
  }
}

export function recordBehaviorsBefore (to) {
  let page_route = to.path
  let page_title = to.meta.title
  let startTime = Moment().format ("YYYY-MM-DD hh:mm:ss")
  localStorage.setItem('startTime', JSON.stringify(startTime));
}

export function recordBehaviorsAfter (from) {
  return new Promise(resolve => {
    let endTime = Moment().format ("YYYY-MM-DD hh:mm:ss")
    let report = {}
    report.startTime = JSON.parse(localStorage.getItem('startTime'))
    report.endTime = endTime
    let duringTime = Moment(report.endTime).diff(report.startTime)
    let chineseName = from.meta.chineseName
    InsertUserBehavior(duringTime,chineseName).then((res) => {
      resolve(res)
    })
  })

}

function InsertUserBehavior(stayTime,chineseName){
  let param1 = new Object();
  let param = new Object();
  let _this = this;
  param1.stayTime = stayTime/1000;
  // param1.page = chineseName + GetUrlRelativePath();
  param1.page = chineseName;
  param.jsonBody = param1;
  return new Promise((resolve, reject) => {
    insertUserBehavior(param)
      .then(res => {
        let jsonBodyData = res.jsonBody;
        let rtnCode = jsonBodyData.rtnCode;
        if (rtnCode == 0) {
          resolve(res)
        }
        // resolve(true)
      })
      .catch(err => {
        // reject(false)
      });
  });
}



// WEBPACK FOOTER //
// ./src/monitoring/performanceMonitoring.js